import { Checkbox } from '@material-ui/core'
import { useState } from 'react'
import Loading from '../LoadingComponent'

type ToggleCheckboxProperties = {
    value: boolean;
    onToggle(newValue: boolean): Promise<boolean>,
}

export default function ToggleCheckbox(props: ToggleCheckboxProperties) {
    const [value, setValue] = useState(props.value);
    const [updating, setUpdating] = useState(false);

    const toggle = async () => {
        const newValue = !value;
        if (props.onToggle) {
            setUpdating(true);
            const result = await props.onToggle(newValue);
            if (result) {
                setValue(newValue);
            }
            setUpdating(false);
        }
    }

    return (
        updating ? (<Loading fullWidth={false} loading={true}/>) :
        (<Checkbox size="small" checked={value} 
            disabled={updating}
            onChange={
                () => {
                    toggle();
                }
            }
        />)
    )
}